import moment from 'moment';
import { mapPeCompanyOrderListItemFromApi } from 'rtkQuery/sharespro/mapper/modules/pe/companyOrders/mapPeCompanyOrderListFromApi';
import { mapPeOrderListItemFromApi } from 'rtkQuery/sharespro/mapper/modules/pe/orders/mapPeOrderListFromApi';
import mapArticleListItemFromApi from 'rtkQuery/sharespro/mapper/modules/articles/mapArticleListItemFromApi';
import mapPeCompanyShortFromApi from './mapPeCompanyShortFromApi';

const mapPeCompanyUserAssetsFromApi = (
  apiItem: ApiPeCompanyUserAsset
): PeCompanyUserAsset => ({
  currentPrice: apiItem.current_price,
  currentSum: apiItem.current_sum,
  purchasePrice: apiItem.purchase_price,
  purchaseDate: new Date(apiItem.purchase_date * 1000),
  quantity: apiItem.quantity,
  sum: apiItem.sum,
  revenue: {
    amount: apiItem.revenue.sum,
    percent: apiItem.revenue.pc,
  },
});

const mapPeCompanyClientsFromApi = (
  apiItem: ApiPeCompanyClient
): PeCompanyClient => ({
  name: apiItem.name,
  volumePercent: +apiItem.volume_percent,
});

const mapPeCompanyInvestmentItemFromApi = (
  apiItem: ApiPeCompanyInvestmentItem
): PeCompanyInvestmentItem => ({
  date: apiItem.date,
  type: apiItem.type,
  income: apiItem.income_m,
  topInvestors: apiItem.top_investors,
});

const mapPeCompanyInvestmentChartPointsFromApi = (
  apiItem: ApiPeCompanyInvestmentChartPoint,
  index: number
): ChartPoint => ({
  pointIndex: index,
  price: apiItem.income_m,
  date: moment().set('year', apiItem.year).toDate(),
});

const mapPeCompanyCompetitorItemsFromApi = (
  apiItem: ApiPeCompanyCompetitorItem
): PeCompanyCompetitorItem => ({
  estimate: apiItem.estimate,
  stockType: apiItem.stock_type,
  investmentIncome: apiItem.investment_income,
  employeesTotal: apiItem.employees_total,
  country: apiItem.country,
  foundationYear: apiItem.foundation_year,
  name: apiItem.name,
  revenueGrowthType: apiItem.revenue_growth_type,
});

const mapPeCompanyDetailFromApi = (
  resp: ApiPeCompanyFullData
): PeCompanyDetail => {
  return {
    ...mapPeCompanyShortFromApi(resp),
    foundationDate: resp.foundation_date
      ? moment(resp.foundation_date).toDate()
      : null,
    headOffice: resp.head_office,
    sector: resp.sector,
    industry: resp.industry,
    website: resp.website,
    description: resp.description,
    investorsDescription: resp.investors_description,
    competitorsDescription: resp.competitors_description,
    businessModel: resp.business_model,
    revenue: resp.revenue,
    employeesTotal: resp.employees_total,
    takeoverTotal: resp.takeover_total,
    report: resp.report
      ? {
          fileUrl: resp.report.file?.url ?? null,
          description: resp.report.description,
        }
      : null,
    estimate: resp.estimate,

    assets: resp.assets.map(mapPeCompanyUserAssetsFromApi),
    clients: resp.clients.map(mapPeCompanyClientsFromApi),
    investments: resp.investments.map(mapPeCompanyInvestmentItemFromApi),
    investmentsChartData: resp.investment_chart.map(
      mapPeCompanyInvestmentChartPointsFromApi
    ),
    competitors: resp.competitors.map(mapPeCompanyCompetitorItemsFromApi),
    estimateFromAnalytics: resp.estimate_from_analytics
      ? {
          product: resp.estimate_from_analytics.product,
          industry: resp.estimate_from_analytics.industry,
          investors: resp.estimate_from_analytics.investors,
          partners: resp.estimate_from_analytics.partners,
          competitors: resp.estimate_from_analytics.competitors,
          finance: resp.estimate_from_analytics.finance,
          team: resp.estimate_from_analytics.team,
          reputation: resp.estimate_from_analytics.reputation,
          clients: resp.estimate_from_analytics.clients,
          description: resp.estimate_from_analytics.description,
          publicDate: moment(resp.estimate_from_analytics.public_date).toDate(),
          action: resp.estimate_from_analytics.action,
          lock_up: resp.estimate_from_analytics.lock_up,
        }
      : null,
    investorsOrders: resp.investor_pe_orders.map(mapPeOrderListItemFromApi),
    sharesproOrders: resp.company_pe_orders.map(
      mapPeCompanyOrderListItemFromApi
    ),
    articles: resp.articles.map(mapArticleListItemFromApi),
  };
};

export default mapPeCompanyDetailFromApi;
